import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/lib/query-keys";
import { appointmentsAPI } from "@/lib/appointments-api";

/**
 * Fetches the available booking modes (teleconsult / clinic) for a service.
 * Only enabled once a service is selected — pass `enabled: false` until then.
 */
export function useServiceModes(serviceId: string | null, enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.services.modes(serviceId ?? ""),
    queryFn: () => appointmentsAPI.getServiceModes(serviceId as string),
    enabled: enabled && Boolean(serviceId),
  });
}
